/**
 * Global Alert Context
 */
import { createContext } from "react";
import { useMap } from "@react-hookz/web";

/**
 * The `GlobalAlertContext` is not intended to be used directly. It is used by
 * the `<GlobalAlert>` component to hoist alerts to within `header-app`.
 */
export var GlobalAlertContext = /*#__PURE__*/createContext(null);
/**
 * The use `<GlobalAlert>` components, you must wrap your application in the
 * `<GlobalAlertProvider>` and pass it the result of the `useGlobalAlertMap()`.
 *
 * @example
 * ```tsx
 * const globalAlertMap = useGlobalAlertMap();
 *
 * return (
 *   <GlobalAlertProvider value={globalAlertMap}>
 *     <App />
 *   </GlobalAlertProvider>
 * );
 * ```
 */

export var GlobalAlertProvider = GlobalAlertContext.Provider;
/**
 * Use this hook to initialize the GlobalAlertContext.
 *
 * @example
 * ```tsx
 * const globalAlertMap = useGlobalAlertMap();
 *
 * return (
 *   <GlobalAlertProvider value={globalAlertMap}>
 *     <App />
 *   </GlobalAlertProvider>
 * );
 * ```
 */

export function useGlobalAlertMap() {
  return useMap();
}